export default __webpack_public_path__ + "static/media/idaten_way.7588960b.png";